export class Homepage {
    ID:number;
CLIENT_ID:number;
BANNER1_TITLE:string;
BANNER1_IMAGE_URL:string;
BANNER2_TITLE:string;
BANNER2_IMAGE_URL:string;
BANNER3_TITLE:string;
BANNER3_IMAGE_URL:string;
DESCRIPTION:string;
EVENT_LIST:string;

}